<template>
  <svg
    key="close"
    viewBox="0 0 30 30"
    width="24"
    fill="currentColor"
    :class="classes"
  >
    <use
      xlink:href="#icon-close"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    />
  </svg>
</template>

<script>
// @flow

export default {
  props: {
    classes: {
      type: String,
      default: ''
    }
  }
}
</script>
